const ROUTER_BASE_NAME = '';

import { __RouterContext as RouterContext, BrowserRouter, matchPath, useLocation, withRouter, } from '@jupiter/plugin-runtime/router';
 import _app from '@_jupiter_src/pages/_app.tsx';

import React from 'react';

const nestedRoutes = [
  {
    "path": "/",
    "exact": true,
    "filePath": "@_jupiter_src/pages/index.tsx",
"component": require("@_jupiter_src/pages/index.tsx").default,
"module": require("@_jupiter_src/pages/index.tsx")
  },
  {
    "path": "/user",
    "filePath": "@_jupiter_src/pages/user/_layout.tsx",
"component": require("@_jupiter_src/pages/user/_layout.tsx").default,
"module": require("@_jupiter_src/pages/user/_layout.tsx"),
    "routes": [
      {
        "path": "/user/:id",
        "exact": true,
        "filePath": "@_jupiter_src/pages/user/[id].tsx",
"component": require("@_jupiter_src/pages/user/[id].tsx").default,
"module": require("@_jupiter_src/pages/user/[id].tsx")
      }
    ]
  },
  {
    "path": "/search",
    "filePath": "@_jupiter_src/pages/search/_layout.tsx",
"component": require("@_jupiter_src/pages/search/_layout.tsx").default,
"module": require("@_jupiter_src/pages/search/_layout.tsx"),
    "routes": [
      {
        "path": "/search",
        "exact": true,
        "filePath": "@_jupiter_src/pages/search/index.tsx",
"component": require("@_jupiter_src/pages/search/index.tsx").default,
"module": require("@_jupiter_src/pages/search/index.tsx")
      }
    ]
  },
  {
    "path": "/:scope",
    "exact": true,
    "filePath": "@_jupiter_src/pages/[scope]/index.tsx",
"component": require("@_jupiter_src/pages/[scope]/index.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/index.tsx")
  },
  {
    "path": "/:scope/post/new",
    "exact": true,
    "filePath": "@_jupiter_src/pages/[scope]/post/new.tsx",
"component": require("@_jupiter_src/pages/[scope]/post/new.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/post/new.tsx")
  },
  {
    "path": "/:scope/billboard",
    "filePath": "@_jupiter_src/pages/[scope]/billboard/_layout.tsx",
"component": require("@_jupiter_src/pages/[scope]/billboard/_layout.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/billboard/_layout.tsx"),
    "routes": [
      {
        "path": "/:scope/billboard",
        "exact": true,
        "filePath": "@_jupiter_src/pages/[scope]/billboard/index.tsx",
"component": require("@_jupiter_src/pages/[scope]/billboard/index.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/billboard/index.tsx")
      }
    ]
  },
  {
    "path": "/:scope/post/:postId",
    "filePath": "@_jupiter_src/pages/[scope]/post/[postId]/_layout.tsx",
"component": require("@_jupiter_src/pages/[scope]/post/[postId]/_layout.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/post/[postId]/_layout.tsx"),
    "routes": [
      {
        "path": "/:scope/post/:postId",
        "exact": true,
        "filePath": "@_jupiter_src/pages/[scope]/post/[postId]/index.tsx",
"component": require("@_jupiter_src/pages/[scope]/post/[postId]/index.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/post/[postId]/index.tsx")
      },
      {
        "path": "/:scope/post/:postId/edit",
        "exact": true,
        "filePath": "@_jupiter_src/pages/[scope]/post/[postId]/edit.tsx",
"component": require("@_jupiter_src/pages/[scope]/post/[postId]/edit.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/post/[postId]/edit.tsx")
      }
    ]
  }
]

const routes = [
  {
    "path": "/",
    "exact": true,
    "filePath": "@_jupiter_src/pages/index.tsx",
"component": require("@_jupiter_src/pages/index.tsx").default,
"module": require("@_jupiter_src/pages/index.tsx")
  },
  {
    "path": "/search",
    "exact": true,
    "filePath": "@_jupiter_builtin/main/components/search_layout_search_index.jsx",
"component": require("@_jupiter_builtin/main/components/search_layout_search_index.jsx").default,
"module": require("@_jupiter_builtin/main/components/search_layout_search_index.jsx")
  },
  {
    "path": "/:scope",
    "exact": true,
    "filePath": "@_jupiter_src/pages/[scope]/index.tsx",
"component": require("@_jupiter_src/pages/[scope]/index.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/index.tsx")
  },
  {
    "path": "/user/:id",
    "exact": true,
    "filePath": "@_jupiter_builtin/main/components/user_layout_user_id.jsx",
"component": require("@_jupiter_builtin/main/components/user_layout_user_id.jsx").default,
"module": require("@_jupiter_builtin/main/components/user_layout_user_id.jsx")
  },
  {
    "path": "/:scope/post/new",
    "exact": true,
    "filePath": "@_jupiter_src/pages/[scope]/post/new.tsx",
"component": require("@_jupiter_src/pages/[scope]/post/new.tsx").default,
"module": require("@_jupiter_src/pages/[scope]/post/new.tsx")
  },
  {
    "path": "/:scope/billboard",
    "exact": true,
    "filePath": "@_jupiter_builtin/main/components/billboard_layout_billboard_index.jsx",
"component": require("@_jupiter_builtin/main/components/billboard_layout_billboard_index.jsx").default,
"module": require("@_jupiter_builtin/main/components/billboard_layout_billboard_index.jsx")
  },
  {
    "path": "/:scope/post/:postId",
    "exact": true,
    "filePath": "@_jupiter_builtin/main/components/post_id_layout_post_id_index.jsx",
"component": require("@_jupiter_builtin/main/components/post_id_layout_post_id_index.jsx").default,
"module": require("@_jupiter_builtin/main/components/post_id_layout_post_id_index.jsx")
  },
  {
    "path": "/:scope/post/:postId/edit",
    "exact": true,
    "filePath": "@_jupiter_builtin/main/components/post_id_layout_post_id_edit.jsx",
"component": require("@_jupiter_builtin/main/components/post_id_layout_post_id_edit.jsx").default,
"module": require("@_jupiter_builtin/main/components/post_id_layout_post_id_edit.jsx")
  }
];


function matchRoutes(routes, pathname, /*not public API*/ branch = []) {
  routes.some(route => {
    const match = route.path
      ? matchPath(pathname, route)
      : branch.length
      ? branch[branch.length - 1].match // use parent match
      : Router.computeRootMatch(pathname); // use default "root" match

    if (match) {
      branch.push({ route, match });

      if (route.routes) {
        matchRoutes(route.routes, pathname, branch);
      }
    }

    return match;
  });

  return branch;
}

// inner App component
const DefaultNotFound = () => (<div style={{margin: "150px auto", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center"}}>
  <img src="https://p16.topbuzzcdn.com/large/69450428ce4b4286a3f413c26d334a7b" useMap="#map1355107823663" width="338" height="338"/>
</div>);

class App extends React.Component{
  // 该函数仅在 browser 端会被使用
  getBaseName() {
    const props = this.props
    let basename = props["router-base"]
    if (props["router-base-getter"] && typeof props["router-base-getter"] === 'function') {
      basename =  props["router-base-getter"](location.pathname)
    }
    return basename
  }

  render() {
    return (
      
        <RouterContext.Consumer>
          {context => {
            // Gar module 应用使用约定式路由时， props 中 location 不正确，优先使用 context.location
            const location = context.location || this.props.location;
            const matched = matchRoutes(routes, location.pathname)[0];
            if (!matched) return (<DefaultNotFound />);
            const props = { ...context, match: matched.match };
            const appProps = {
              ...props,
              ...this.props,
              matches: matched,
            };

            const getComponentElement = () => {
              // 表示包裹了一层 layout, 可以当作纯函数执行
              if (matched.route.component.__isWrappedByLayout__) {
                return matched.route.component(props);
              }

              return <matched.route.component {...props} />
            };

            return (
              <RouterContext.Provider value={props}>
                <_app Component={matched.route.component} {...appProps} />
              </RouterContext.Provider>
            );
          }}
        </RouterContext.Consumer>
      
    );
  }
}

App.__routes = nestedRoutes;
App.models = _app.models;
App.config = _app.config;
App.init = _app.init;

export default App
